import { Component, OnInit,Inject,ViewChild } from '@angular/core';
import {
  MatPaginator,
  MatSort,
  MatTableDataSource,
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material";
import { EmsComponent } from '../ems/ems.component';
import { EmsdashboardService } from '../services/emsdashboard.service';
export interface alertData {
 
  date,
    time,
    sitename,
    parametername,
    actual,
    threshold,
    transformer
 }
@Component({
  selector: 'app-emsalerttabledialog',
  templateUrl: './emsalerttabledialog.component.html',
  styleUrls: ['./emsalerttabledialog.component.scss']
})
export class EmsalerttabledialogComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  latestAlertsArray = [];
  datas = [];
  ELEMENT_DATA: alertData[] = [];
  displayedColumns: string[] = [
   
    "date",
    "time",
    "sitename",
    "parametername",
    "actual",
    "threshold",
    "transformer"
  ];
  dataSource;
  alertsData;
  constructor(@Inject(MAT_DIALOG_DATA) public data,private emsService:EmsdashboardService,private dialogRef: MatDialogRef<EmsComponent>) { }

  ngOnInit() {
    this.getLastUpdatedAlertsData()
    setInterval(() => {
     this.updateTable();
    }, 1000);
  }
  getLastUpdatedAlertsData(){
    this.emsService.getLastUpdatedEMSAlertsData({userid:this.data.currentUserData.userid,roleid:this.data.currentUserData.roleid,type:"alertpopuptable"}).subscribe((response: any) => {
      response.result.forEach(item => {
        this.ELEMENT_DATA.push({
         
          date:item.date,
          time:item.time,
          sitename:item.sitename,
          parametername:item.parametername,
          actual:item.actualvalue,
          threshold:item.thresholdvalue,
          transformer:item.energyMeterId
        })
      });
      this.datas = response.result;
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA.slice().reverse());
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.siteNameFilerArray();
      this.parameterFilerArray();
    });
  }
  updateTable(){
    if(this.data.hasOwnProperty("newData")){
      if( this.datas[this.datas.length-1].id !== this.data.newData.id){
      this.ELEMENT_DATA.push({
        
        date:this.data.newData.date,
        time:this.data.newData.time,
        sitename:this.data.newData.sitename,
        parametername:this.data.newData.parametername,
        actual:this.data.newData.actualvalue,
        threshold:this.data.newData.thresholdvalue,
        transformer:this.data.newData.energyMeterId
      })
    this.dataSource.data  = this.ELEMENT_DATA.slice().reverse();
    this.datas.push(this.data.newData)
      }
  }
  }
  siteNameFilerArray(){
    let siteNameArray = [];
    const checkboxContainer = document.getElementById('checkboxContainer');
    for(let i=0;i<this.ELEMENT_DATA.length;i++){
      if(!siteNameArray.includes(this.ELEMENT_DATA[i].transformer)){
        siteNameArray.push(this.ELEMENT_DATA[i].transformer);
      }
    }
    console.log(">>>>>>>>",siteNameArray)
    siteNameArray.forEach(value => {
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.name = value; 
      checkbox.value = value;
      
      const label = document.createElement('label');
      label.appendChild(checkbox);
      label.appendChild(document.createTextNode(value));
      const container = document.createElement('div'); 
      container.appendChild(label);
      checkboxContainer.appendChild(container);
    });
  }
  parameterFilerArray(){
    let parameterNameArray = [];
    const checkboxContainer = document.getElementById('checkboxContainer1');
    for(let i=0;i<this.ELEMENT_DATA.length;i++){
      if(!parameterNameArray.includes(this.ELEMENT_DATA[i].parametername.replace('ap', ''))){
        parameterNameArray.push(this.ELEMENT_DATA[i].parametername.replace('ap', ''));
      }
    }
    console.log(">>>>>>>>",parameterNameArray)
    parameterNameArray.forEach(value => {
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.name = value; 
      checkbox.value = value;
      
      const label = document.createElement('label');
      label.appendChild(checkbox);
      label.appendChild(document.createTextNode(value));
      const container = document.createElement('div'); 
      container.appendChild(label);
      checkboxContainer.appendChild(container);
    });
  }
  applyFilter() {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    let checkedValues: string[] = [];
    
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', event => {
        const target = event.target as HTMLInputElement; 
        const value = target.value;
        const isChecked = target.checked; 
        if (isChecked) {
          checkedValues.push(value);
        } else {
          const index = checkedValues.indexOf(value);
          if (index !== -1) {
            checkedValues.splice(index, 1);
          }
        }
            if (checkedValues.length === 0) {
          this.dataSource.filter = '';
        } else {
          this.dataSource.filter = checkedValues.join(',');
        }
      });
    });
  }
  searchByInput(){
    let inputElement = document.getElementById('inputsearch') as HTMLInputElement;
    let value = inputElement.value;
    this.dataSource.filter = value;
  }
  close() {
    this.dialogRef.close();
  }
}
